export const svgDefs = {
  circle: `
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z" />
      </g>
    </svg>
  `,
  rectangle: `
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M100 0H0V100H100V0Z" />
      </g>
    </svg>
  `,
  roundedRectangle: `
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M90 0H10C4.47715 0 0 4.47716 0 10V90C0 95.5229 4.47716 100 10 100H90C95.5229 100 100 95.5228 100 90V10C100 4.47715 95.5228 0 90 0Z" />
      </g>
    </svg>
  `,
  triangle: `
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M50.0006 0L74.9997 50.0007L100 100H50.0006H0L25.0003 50.0007L50.0006 0Z" />
      </g>
    </svg>
  `,
  diamond: `
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M50 0L0 50L50 100L100 50L50 0Z" />
      </g>
    </svg>
  `,
  pentagon: `
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M50.0006 0L0 38.1966L19.0982 100H80.9018L100 38.1966L50.0006 0Z" />
      </g>
    </svg>
  `,
  hexagon: `
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M74.9994 0H24.9994L0 49.9993L24.9994 100H74.9994L100 49.9993L74.9994 0Z" />
      </g>
    </svg>
  `,
  octagon: `
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M70.7101 0H29.2899L0 29.289V70.711L29.2899 100H70.7101L100 70.711V29.289L70.7101 0Z" />
      </g>
    </svg>
  `,
  parallelogram: `
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M68.5983 100H0L31.4005 0H100L68.5983 100Z" />
      </g>
    </svg>
  `,
  trapezoid: `
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M75.0006 0L100 100H50H0L24.9994 0" />
      </g>
    </svg>
  `,
  halfCircle: `
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M50 0.532537L0 0C0 0.176728 0 0.355808 0 0.532537C0 55.0992 22.5706 100 50 100C77.4294 100 100 55.0992 100 0.532537H50Z" />
      </g>
    </svg>
  `,
  pill: `
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M74.5854 0H25.4146C11.3785 0 0 22.3858 0 50C0 77.6142 11.3785 100 25.4146 100H74.5854C88.6215 100 100 77.6142 100 50C100 22.3858 88.6215 0 74.5854 0Z" />
      </g>
    </svg>
  `,
  fourPointStar: `
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M50.0005 0L58.7256 41.2743L100 49.9995L58.7256 58.7246L50.0005 100L41.2754 58.7246L0 49.9995L41.2754 41.2743L50.0005 0Z" />
      </g>
    </svg>
  `,
  fivePointStarAlt: `
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M49.9994 0L67.5989 29.809L100 38.1971L78.476 65.0065L80.9022 100L49.9994 86.7605L19.0978 100L21.524 65.0065L0 38.1971L32.4011 29.809L49.9994 0Z" />
      </g>
    </svg>
  `,
  fivePointStar: `
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M50.0005 0L61.8035 38.1964H100L69.0988 61.8036L80.9017 100L50.0005 76.3929L19.0983 100L30.9023 61.8036L0 38.1964H38.1965L50.0005 0Z" />
      </g>
    </svg>
  `,
  sixPointStar: `
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M50 0L66.6658 24.9997H100L83.3329 49.9995L100 75.0003H66.6658L50 100L33.3329 75.0003H0L16.6658 49.9995L0 24.9997H33.3329L50 0Z" />
      </g>
    </svg>
  `,
  eightPointStar: `
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M50 0L64.6444 14.6454H85.3556V35.3552L100 49.9994L85.3556 64.6448V85.3547H64.6444L50 100L35.3556 85.3547H14.6444V64.6448L0 49.9994L14.6444 35.3552V14.6454H35.3556L50 0Z" />
      </g>
    </svg>
  `,
  starBurst: `
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M97.7435 64.9551L90.1505 68.3756L92.4856 76.3772L84.2831 77.7985L84.5572 86.1314L76.2587 85.4643L74.4555 93.6038L66.5838 90.891L62.8156 98.3262L55.8645 93.7381L50.3695 100L44.7763 93.825L37.898 98.522L34.0142 91.1481L26.1852 93.9849L24.2549 85.8743L15.9679 86.6724L16.1113 78.336L7.88679 77.0444L10.0959 69.0057L2.45082 65.7068L6.58563 58.4708L0 53.3719L5.80262 47.3926L0.690484 40.8134L7.79427 36.4674L4.47716 28.8213L12.4368 26.3819L11.1218 18.1497L19.4377 17.7698L20.2091 9.4681L28.3585 11.1708L31.1655 3.32206L38.6359 7.00088L43.3051 0.0984574L49.627 5.52287L55.8633 0L60.6389 6.82829L68.0503 3.03132L70.9811 10.8349L79.1027 9.00362L80.0037 17.2914L88.3254 17.5404L87.1399 25.7934L95.1377 28.1066L91.9397 35.8048L99.1117 40.0373L94.1037 46.6965L100 52.5831L93.4942 57.7862L97.7435 64.9551Z" />
      </g>
    </svg>
  `,
  promoCircle: `
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M93.9749 69.1979L92.9155 69.6744L93.2418 70.7909C94.3989 74.7542 91.8524 78.8426 87.789 79.5456L86.6442 79.7437L86.6826 80.906C86.8185 85.0327 83.3362 88.3586 79.2258 88.0281L78.0675 87.9352L77.8153 89.0703C76.9215 93.1005 72.7234 95.4559 68.8244 94.1117L67.7254 93.733L67.2 94.7702C65.3334 98.4513 60.6828 99.6866 57.2387 97.4153L56.2683 96.7754L55.5018 97.6493C52.7797 100.751 47.9672 100.788 45.1969 97.731L44.4168 96.8695L43.4575 97.5242C40.0506 99.85 35.3802 98.689 33.4567 95.0376L32.9152 94.009L31.8224 94.4051C27.9444 95.8099 23.7092 93.5213 22.7536 89.506L22.4841 88.3747L21.3283 88.4861C17.2241 88.8809 13.6898 85.6107 13.7615 81.4828L13.7813 80.3193L12.6341 80.1385C8.56079 79.4986 5.94994 75.4511 7.04398 71.4704L7.35179 70.349L6.28495 69.8886C2.49846 68.2547 0.97546 63.6836 3.02385 60.1003L3.60115 59.0903L2.68266 58.3786C-0.579681 55.8535 -0.919637 51.0472 1.95453 48.0865L2.76424 47.2522L2.05096 46.3338C-0.482021 43.0748 0.38332 38.3354 3.90279 36.1829L4.89422 35.5764L4.43065 34.5094C2.78773 30.7231 4.8015 26.3476 8.74499 25.1395L9.85633 24.7991L9.67338 23.6505C9.0219 19.5732 12.0605 15.8364 16.1795 15.6483L17.3403 15.5951L17.4478 14.4365C17.8298 10.3259 21.7004 7.46292 25.7366 8.30584L26.8739 8.54349L27.2658 7.44806C28.6565 3.56147 33.1167 1.75185 36.8167 3.57384L37.8588 4.08752L38.5103 3.12453C40.8232 -0.294185 45.5925 -0.935349 48.7238 1.75061L49.6064 2.50689L50.4767 1.73576C53.566 -0.999713 58.3439 -0.432815 60.71 2.94877L61.3763 3.90185L62.411 3.37209C66.0825 1.49192 70.5699 3.22974 72.0224 7.0953L72.4316 8.18454L73.5652 7.92956C77.5878 7.02227 81.5029 9.82458 81.9491 13.929L82.0752 15.0851L83.236 15.1198C87.3575 15.2435 90.4542 18.9308 89.867 23.018L89.7014 24.1691L90.8177 24.4921C94.7797 25.6383 96.8627 29.9817 95.2791 33.794L94.8328 34.8684L95.8342 35.4588C99.387 37.5556 100.325 42.2801 97.8442 45.5788L97.1458 46.5083L97.9691 47.329C100.889 50.2439 100.626 55.0551 97.4029 57.6322L96.4955 58.3575L97.0889 59.3576C99.1929 62.9088 97.7429 67.5022 93.9811 69.1954L93.9749 69.1979Z" />
      </g>
    </svg>
  `,
  plus: `
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M38.6744 0H61.3258V38.5533H100V61.4453H61.3258V100H38.6744V61.4453H0V38.5533H38.6744V0Z" />
      </g>
    </svg>
  `,
  arrowLeft: `
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M42.0072 0L0 50.0007L42.0072 100V76.9378H100V23.0636H42.0072V0Z" />
      </g>
    </svg>
  `,
  arrowRight: `
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M57.9923 0L100 50.0007L57.9923 100V76.9378H0V23.0636H57.9923V0Z" />
      </g>
    </svg>
  `,
  arrowUp: `
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M100 42.0077L49.9993 0L0 42.0077H23.0622V100H76.9364V42.0077H100Z" />
      </g>
    </svg>
  `,
  arrowDown: `
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M23.0637 0H76.938V57.9923H100L50.0007 100L0 57.9923H23.0637V0Z" />
      </g>
    </svg>
  `,
  arrowLeftRight: `
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M26.8264 100L0 50.0007L26.8264 0V23.0635H73.1736V0L100 50.0007L73.1736 100V76.9377H26.8264V100Z" />
      </g>
    </svg>
  `,
  crescent: `
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M100 95.697C65.9526 94.2044 38.9951 74.3186 38.9951 50.0012C38.9951 25.6837 65.9526 5.79672 100 4.30416C91.1699 1.53966 81.3938 0 71.1046 0C31.835 0 0 22.386 0 50C0 77.614 31.835 100 71.1046 100C81.3938 100 91.1699 98.4615 100 95.6958V95.697Z" />
      </g>
    </svg>
  `,
  splash: `
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M36.0033 95.7356C43.1855 86.644 56.8124 86.644 63.9946 95.7356L67.3637 100L67.2453 94.5344C66.9918 82.8824 77.4309 73.9877 88.6882 76.2644L93.9691 77.333L90.4178 73.2236C82.848 64.463 85.2134 50.836 95.2786 45.2321L100 42.6033L94.6783 41.7722C83.333 40.0025 76.5195 28.0195 80.6826 17.1581L82.6353 12.0626L78.0322 14.8995C68.2206 20.949 55.416 16.2167 51.7296 5.17788L50 0L48.2704 5.17788C44.584 16.2153 31.7794 20.9476 21.9678 14.8995L17.3647 12.0626L19.3174 17.1581C23.4805 28.0195 16.667 40.0025 5.32171 41.7722L0 42.6033L4.72145 45.2321C14.7866 50.836 17.152 64.4616 9.58222 73.2236L6.03092 77.333L11.3118 76.2644C22.5691 73.9877 33.0072 82.881 32.7547 94.5344L32.6363 100L36.0054 95.7356H36.0033Z" />
      </g>
    </svg>
  `,
  heart: `
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M7.53163 50.8267C-2.51054 39.2004 -2.51054 20.3481 7.53163 8.72062C17.5728 -2.90687 33.8537 -2.90687 43.8958 8.72062L50.0004 15.7891L56.1042 8.72178C66.1463 -2.90571 82.4272 -2.90571 92.4684 8.72178C102.511 20.3493 102.511 39.2004 92.4684 50.8267L50.0005 100L7.53163 50.8267Z" />
      </g>
    </svg>
  `,
  drop: `
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M39.858 8.18723C23.8183 22.1542 0 42.8947 0 65.8934L0.00154959 65.8934C0.00154959 84.73 22.387 100 50.0008 100C77.6146 100 100 84.73 100 65.8934C100 65.663 99.9966 65.4331 99.99 65.2037C99.4862 44.6553 76.6264 24.6583 60.4996 10.5512C55.8783 6.50856 51.8098 2.94962 48.9789 0C46.5395 2.36912 43.387 5.11423 39.858 8.18723Z" fill="#04AF00"/>
      </g>
    </svg>
  `,
  cloud: `
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M51.4874 0C59.3519 0 65.9912 7.52065 68.0978 17.8195C74.7018 12.4414 83.2473 13.7888 88.8782 21.8619C94.6262 30.103 95.4859 42.6989 91.4572 52.243C96.5842 56.789 100 64.923 100 74.2008C100 88.4493 91.9436 100 82.0055 100H17.9945C8.0564 100 0 88.4493 0 74.2008C0 64.5386 3.70476 56.1169 9.18877 51.6965C7.03561 42.9635 8.3954 32.8478 13.2682 25.8615C18.9674 17.6904 27.6526 16.4093 34.2884 22.0182C35.2576 9.6299 42.5882 0 51.4874 0Z" />
      </g>
    </svg>
  `,
  bookmark: `
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M100 100L48.6843 69.3279L0 100V0H100V100Z" />
      </g>
    </svg>
  `,
  pointer: `
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M44.75 55.2506L0 38.2548L49.8957 18.4079L100 0L81.5912 50.1049L61.7456 100L44.75 55.2506Z" />
      </g>
    </svg>
  `,
  ticket: `
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M99.9989 80.2716C93.8455 80.2716 88.8582 89.1034 88.8582 100H11.1408C11.1408 89.1034 6.1534 80.2716 0 80.2716V19.7284C6.1534 19.7284 11.1408 10.8966 11.1408 0H88.8592C88.8592 10.8966 93.8466 19.7284 100 19.7284V80.2716H99.9989Z" />
      </g>
    </svg>
  `,
}
